import { render, staticRenderFns } from "./schemeManage.vue?vue&type=template&id=935d3d16&scoped=true"
import script from "./schemeManage.vue?vue&type=script&lang=js"
export * from "./schemeManage.vue?vue&type=script&lang=js"
import style0 from "./schemeManage.vue?vue&type=style&index=0&id=935d3d16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935d3d16",
  null
  
)

export default component.exports